import { QueryClient } from '@tanstack/react-query'
import { UploadedDocument } from '@urbanx/agx-ui-components'
import {
  AutopilotTaskDto,
  TaskCategoryTaskType,
} from '@urbanx/agx.activities.client'
import {
  DocumentTypes,
  UploadedDocument as CampaignUploadedDocument,
} from '@urbanx/agx.campaigns.client'

export enum ConnectionState {
  NotConnected,
  Connecting,
  Connected,
  Reconnecting,
  Disconnected,
}

export enum NotificationType {
  PdfProcessedEvent = 'PdfProcessedEvent',
  ReadyForDocuSignEvent = 'ReadyForDocuSignEvent',
  CampaignUpdatedEvent = 'CampaignUpdatedEvent',
  RexListingCreatedEvent = 'RexListingCreatedEvent',
  TaskUpdatedNotification = 'TaskUpdatedNotification',
  TaskCreatedNotification = 'TaskCreatedNotification',
  ContractDocumentUpdatedNotification = 'ContractDocumentUpdatedNotification',
}

export interface PushNotification {
  registerEvent: (
    eventType: string,
    callback: (event: NotificationEvents, queryClient: QueryClient) => void,
    id?: (string | undefined)[]
  ) => void
  unregisterEvent: (
    eventType: string,
    eventCallback: (event: NotificationEvents) => void,
    id?: (string | undefined)[]
  ) => void
}

export interface PdfProcessedEvent {
  campaignId: string
  formId: string
  uploadedDocument: UploadedDocument
}

export interface CampaignUpdatedEvent {
  campaignId: string
  agencyId: string
}

export interface RexListingCreatedEvent {
  campaignId: string
  agencyId: string
  rexListingId: number
}

export interface TaskUpdatedNotification {
  task: AutopilotTaskDto
}

export interface TaskCreatedNotification {
  campaignId?: string
  taskType?: TaskCategoryTaskType
  contractId?: string
  assignee?: string
  dueDate?: string
  isLocked?: boolean
}

export interface ContractDocumentUpdatedNotification {
  campaignId: string
  contractId: string
  documentType: DocumentTypes
  document: CampaignUploadedDocument
}

export type NotificationEvents = PdfProcessedEvent &
  CampaignUpdatedEvent &
  RexListingCreatedEvent &
  TaskUpdatedNotification &
  TaskCreatedNotification &
  ContractDocumentUpdatedNotification
